var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoVfLWolfsburg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Ebene_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 85 85"
    },
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#65b32e}")), /*#__PURE__*/React.createElement("path", {
    d: "M78 42.6C78 62.2 62.1 78 42.5 78S7 62.2 7 42.6C7 23 22.9 7 42.5 7S78 21.1 78 42.6z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 42.5C8.3 20.9 23.2 12.1 33 9c4.5-1.4 8.4-1.5 8.4-.9 0 .4-3.4.1-8.1 1.8-8.3 3-20 10.4-20.7 29.4 0 17.5 14.2 31.6 31.7 31.6s31.6-14.2 31.6-31.6c0-3.7-.6-6.7-1.5-9.2-1.5-4.5-3.4-6.6-2.6-6.6.6 0 2.3 3.5 3.5 6.8 1.4 3.8 2 7.3 2 12.3 0 19.2-15.6 34.8-34.8 34.8-19.2-.1-34.8-15.6-34.8-34.9z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31.6c0-6.2 10.2-5.6 10.2-5.6v22c0 1.5 1 2.5 2.7 2.5 2.8 0 2.6-2.5 2.6-2.5V25.3c0-5.5 10.1-5.5 10.1-5.5V51c-.9 5.5-5.7 9.8-11.3 9.8-3.7 0-7-1.8-9.1-4.7-2.2 2.9-5.5 4.7-9.2 4.7-5.7 0-10.4-4.2-11.3-9.8l-.1-1.8V25.4c0-5.5 10.1-5.5 10.1-5.5v28.3c0 1.6 1.1 2.5 2.6 2.5s2.8-.9 2.8-2.5C39 48 39 36.8 39 31.6z",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVfLWolfsburg);
export default __webpack_public_path__ + "static/media/Logo-VfL-Wolfsburg.0311188839d788dab91d0bd02faaa676.svg";
export { ForwardRef as ReactComponent };